<template>
  <div class="standard-content">
    <slot name="icon"></slot>
    <h1 v-if="title" class="title" v-html="title"></h1>
    <p v-if="description" class="description" v-html="description"></p>
    <div class="button-area">
      <slot name="buttons">
        <button
          type="button"
          class="button button-gray"
          @click="$emit('on-cancel')"
          v-html="cancelText"
        ></button>
        <button
          type="button"
          class="button button-primary"
          @click.prevent="$emit('on-confirm')"
          v-html="confirmText"
        ></button>
      </slot>
    </div>
  </div>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'
  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })

  const title = computed(() => getTextBreaks(props.payloads?.title) ?? '')
  const description = computed(
    () => getTextBreaks(props.payloads?.description) ?? '',
  )
  const confirmText = computed(() =>
    getTextBreaks(props.payloads?.confirmText ?? '확인'),
  )
  const cancelText = computed(() =>
    getTextBreaks(props.payloads?.cancelText ?? '취소'),
  )
</script>
<style scoped lang="scss">
  .standard-content {
    .title {
      color: #fff;
      font-size: 24px;
      font-weight: normal;
      line-height: 1.5em;
      text-align: center;
    }
    .description {
      margin-top: 24px;
      font-size: 16px;
      text-align: center;
      line-height: 1.5em;
    }
    .button-area {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      > .button {
        padding: 0 40px;
        width: 100%;
        height: 60px;
        line-height: 48px;
        border-radius: 30px;
        font-size: 18px;
        color: #fff;
        & + .button {
          margin-left: 8px;
        }
        &.button-primary {
          background: #1351f9;
        }
        &.button-gray {
          background: #5e5e5e;
        }
      }
    }
  }
</style>
